import {
  ContentBlock,
  Card,
  Stack,
  Heading,
  Text,
  Box,
  Column,
  Columns,
  Hidden,
} from 'braid-design-system';
import React from 'react';

import * as styles from './Error.css';

interface Props {
  isFullPage?: boolean;
}

export const Error = ({ isFullPage }: Props) => (
  <Box
    paddingY={isFullPage ? 'xxlarge' : 'small'}
    data={{ testid: 'error-message' }}
    id="error-message"
  >
    <ContentBlock>
      <Card>
        <Columns space="small" alignY="center" collapseBelow="tablet">
          <Column>
            <Stack space="medium">
              <Heading level="2">{"Houston, we've had a problem"}</Heading>
              <Text size="large">
                {"Stand by, we promise we're looking at it."}
              </Text>
              <Text>
                Get back to your mission by refreshing the page or clearing your
                browser history. If the problem continues, contact us.
              </Text>
            </Stack>
          </Column>
          <Hidden below="tablet">
            <Column width="content">
              <div className={styles.errorImage} />
            </Column>
          </Hidden>
        </Columns>
      </Card>
    </ContentBlock>
  </Box>
);
